/** Generated js for domain-specific scripting
 * by common\modules\domains\helpers\DomainJavascriptWriter
 */



// ***************************** //
//         Swiper Slider         //
// ***************************** //
const placeholderSwiper = new Swiper('.placeholder-slider', {
 // Optional parameters
 speed: 900,
 spaceBetween:              0,
 containerModifierClass:    'placeholder-slider-', // instead of 'swiper-container-'
 wrapperClass:              'placeholder-wrapper', // instead of 'swiper-wrapper'
 slideClass:                'placeholder-item', // instead of 'swiper-slide'
 slideActiveClass:          'placeholder-item-active', // instead of 'swiper-slide-active'
 slideBlankClass:           'placeholder-item-invisible-blank', // instead of 'swiper-slide-invisible-blank'
 slideDuplicateClass:       'placeholder-item-duplicate', // instead of 'swiper-slide-duplicate'
 slideDuplicateActiveClass: 'placeholder-item-duplicate-active', // instead of 'swiper-slide-duplicate-active'
 slideDuplicateNextClass:   'placeholder-item-duplicate-next', // instead of 'swiper-slide-duplicate-next'
 slideDuplicatePrevClass:   'placeholder-item-duplicate-prev', // instead of 'swiper-slide-duplicate-prev'
 slideNextClass:            'placeholder-item-next', // instead of 'swiper-slide-next'
 slidePrevClass:            'placeholder-item-prev', // instead of 'swiper-slide-prev'
 clickableClass:            'placeholder-slider-pagination-clickable', // instead of 'swiper-pagination-clickable',

 centeredSlides: true,
 direction: 'horizontal',
 loop: true,
 autoplay: {
    delay: 2000,
 },
 pagination: {
          el: ".swiper-pagination",
},

 navigation: {
   nextEl: '.placeholder-button-next',
   prevEl: '.placeholder-button-prev',
   clickable: true,
 }
});



const streamerSlider = new Swiper('.streamer-slider', {
 // Optional parameters
 speed: 900,
 spaceBetween:              0,
 containerModifierClass:    'streamer-slider-', // instead of 'swiper-container-'
 wrapperClass:              'streamer-wrapper', // instead of 'swiper-wrapper'
 slideClass:                'streamer-item', // instead of 'swiper-slide'
 slideActiveClass:          'streamer-item-active', // instead of 'swiper-slide-active'
 slideBlankClass:           'streamer-item-invisible-blank', // instead of 'swiper-slide-invisible-blank'
 slideDuplicateClass:       'streamer-item-duplicate', // instead of 'swiper-slide-duplicate'
 slideDuplicateActiveClass: 'streamer-item-duplicate-active', // instead of 'swiper-slide-duplicate-active'
 slideDuplicateNextClass:   'streamer-item-duplicate-next', // instead of 'swiper-slide-duplicate-next'
 slideDuplicatePrevClass:   'streamer-item-duplicate-prev', // instead of 'swiper-slide-duplicate-prev'
 slideNextClass:            'streamer-item-next', // instead of 'swiper-slide-next'
 slidePrevClass:            'streamer-item-prev', // instead of 'swiper-slide-prev'
 clickableClass:            'streamer-slider-pagination-clickable', // instead of 'swiper-pagination-clickable',

 centeredSlides: true,
 direction: 'horizontal',
 loop: true,
 autoplay: {
    delay: 2000,
 },
 pagination: {
          el: ".swiper-pagination",
},

 navigation: {
   nextEl: '.streamer-button-next',
   prevEl: '.streamer-button-prev',
   clickable: true,
 }
});